module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABFUlEQVQokZXSvS+DYRQF8F+bmkwS/gUMiFixMmgsBsHuY5CI/4QIgxhFJLqITmwl6eQjBJPdR8JisZCnuU3eVitxkmd47jnnufe95829Vtdk0I11FNEb5UccYxNvdWk+Y5rBPTqxGI+ks4wuPISmhkLGtIFJXGlENc4eToIpJWMPdjCB64zlHN8Yj3vipnCKSjKuYr/JlDDqN25Cu5a+cRqHLUTtkLTFZOzH5T+MaQd9hT8EF23qHfgqRE4jsbksxtoYB/CUj3DnWwjSVist6gsop45buIuc0tayyDXdhzCbuqaOL1iJcIebRs2Om7hyaF/qyynF62eR0wFugxuM8eawFNqGf/UoovnELt7xjG18BFczwQ9S7jpzBhlgsQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/init.png
// module id = hX6l
// module chunks = 1